import React, {Component} from 'react';
import Resize from 'react-resize-detector';
import PropTypes from 'prop-types';

import * as d3 from 'd3';
import _ from 'lodash';

import HoverOver from '../HoverOver';
import './HorizBarChart.css';

class HorizBarChart extends Component {

  constructor(props) {
    super(props);

    this.state = {
      margin: {left: 15, right: 15, top: 10, bottom: 40},
      width: 500,
      height: props.height || 250
    };
  }

  componentDidMount() {
    this.handelResize();
  }

  componentDidUpdate() {
    setTimeout(this.renderD3.bind(this), 100);
  }

  handelResize() {
    const bounds = d3.select(this.refs.wrapper).node().getBoundingClientRect();
    const width = bounds.width || 100;
    const height = 240;

    let mergedState = _.merge({}, this.state, {
      width: width,
      height: height
    });

    this.setState(mergedState);
  }

  renderD3() {
    const width = this.state.width - this.state.margin.left - this.state.margin.right;
    const height = this.state.height - this.state.margin.top - this.state.margin.bottom;
    const props = this.props;
    const self = this;

    const valueX = row => _.get(row, props.dimX, 0);
    const valueY = row => _.get(row, props.dimY, 0);

    const valuesY = _.chain(props.data).map(valueY).uniq().reverse().value();
    const maxX = d3.max(props.data, valueX);

    const y = d3.scaleBand().domain(valuesY).rangeRound([height, 0]).paddingInner(0.18);
    const x = d3.scaleLinear().domain([1, maxX]).range([40, width]);
    const axisX = d3.axisBottom(x).tickSizeInner(height + 5, 0).tickSizeOuter(0).ticks(6);

    const colorScale = d3.scaleLinear()
      .domain(d3.extent(props.data, valueX))
      .range(['#ad9ea5', '#5d434c']);

    // Add the Y Axis only if no bar labels
    d3.select(this.refs.xAxis)
      .transition()
      .duration(300)
      .call(axisX);

    // Add bars
    const bars = d3.select(this.refs.bars)
      .selectAll("rect")
      .data(props.data);

    bars.enter().append("rect").attr("width", 40).each(addBars);
    bars.each(addBars);
    bars.exit().remove();

    // Adds bar rectangles to selection
    function addBars() {
      d3.select(this)
        .attr("class", function (d) {
          return 'heat-bar HEAT_' + valueX(d);
        })
        .attr("rx", y.bandwidth() / 2)
        .attr("ry", y.bandwidth() / 2)
        .attr("x", 0)
        .attr("y", function (d) {
          return y(valueY(d));
        })
        .attr("height", y.bandwidth())
        .on('mouseenter', d => {
          const p = {sn: valueX(d), dimX: props.dimX, titleX: 'Overdose Deaths'};
          const data = {sn: 'Ages: ' + valueY(d), ...d};
          const cy = y(valueY(d)) + y.bandwidth() / 2;
          const cx = x(valueX(d));
          self.setState({hover: {coords: [cx, cy], props: p, data}});
          d3.select('.HeatMap').attr("class", "HeatMap highlight-" + valueX(d));
        })
        .on("mouseout", d => {
          self.setState({hover: null});
          d3.select('.HeatMap').attr("class", "HeatMap");
        })
        .on("click", d => {
          if (props.onClick) {
            props.onClick(d);
          }
        })
        .transition()
        .duration(300)
        .attr("fill", d => colorScale(valueX(d)))
        .attr("width", function (d) {
          return x(valueX(d));
        })
    }

    const values = d3.select(this.refs.labels)
      .selectAll("text")
      .data(props.data);

    values.enter().append("text").each(addValues);
    values.each(addValues);
    values.exit().remove();

    function addValues() {
      d3.select(this)
        .attr("alignment-baseline", "middle")
        .text(d => valueY(d))
        .attr("x", d => y.bandwidth() / 2 - 3)
        .attr("y", d => {
          return y(valueY(d)) + y.bandwidth() / 2 + 1;
        });
    }
  }

  render() {
    return (
      <div ref="wrapper" className="HorizBarChart" height={this.state.height}>
        <Resize handleWidth onResize={this.handelResize.bind(this)}/>
        <svg width={this.state.width} height={this.state.height}>
          <g transform={"translate(" + this.state.margin.left + "," + this.state.margin.top + ")"} ref="svg">
            <g className="axis">
              <g ref="xAxis"></g>
            </g>
            <g ref="bars"></g>
            <g ref="labels" className="labels"></g>
          </g>
        </svg>
        <HoverOver data={this.state.hover} {...this.state.margin}/>
      </div>
    );
  }
}

HorizBarChart.propTypes = {
  dimX: PropTypes.string,
  dimY: PropTypes.string,
  data: PropTypes.array,
  onClick: PropTypes.func
};

export default HorizBarChart;



// WEBPACK FOOTER //
// ./src/charts/HorizBarChart/index.js